import html2canvas from "html2canvas";
import { ChangeEvent, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "react-multi-carousel/lib/styles.css";
import { useDispatch } from "react-redux";
import Select from "react-select";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import invoiceCredit from "../../assets/images/icon_invoice/InvoiceCredit.svg";
import invoiceNonCredit from "../../assets/images/icon_invoice/InvoiceNonCredit.svg";
import invoiceCreditPartial from "../../assets/images/icon_invoice/InvoiceCreditPartial.svg";
import autoDebetPartial from "../../assets/images/icon_invoice/icon_autodebet/perdetail.svg";
import autoDebetNonCredit from "../../assets/images/icon_invoice/icon_autodebet/noncredit.svg";
import autoDebetCredit from "../../assets/images/icon_invoice/icon_autodebet/credit.svg";
import { formatCurrency } from "../../config/global";
import { setCustomApp } from "../../core/feature/company/customAppsSlice";
import { setLoading } from "../../core/feature/config/configSlice";
import { useAppSelector } from "../../core/feature/hooks";
import { setLanguage } from "../../core/feature/language/languageSlice";
import {} from "../../core/feature/store";
import { setToken } from "../../core/feature/token/tokenSlice";
import {
  removeBalance,
  setBalance,
} from "../../core/feature/user/balanceSlice";
import { removeUser, setUser } from "../../core/feature/user/userSlice";
import CustomApp from "../../core/models/customApp";
import User from "../../core/models/user";
import { credentialCheck, getCustomApps } from "../../core/service/api";
import { getBalance } from "../../core/service/api_balance";
import {
  getAllInvoice,
  getAllInvoiceHistory,
  getAllInvoicePaid,
  getAllInvoiceSummary,
  getInvoiceTags,
  invoicePayment,
} from "../../core/service/api_invoice";
import useAnalyticsEventTracker from "../../core/service/useAnalyticsEventTracker";
import { i18n } from "../../translations/i18n";
import { StatsInvoice } from "../common/home/Stats";
import { InvoiceTabComponent } from "./components/InvoiceTabComponent";
import { InvoiceConfirmationModal } from "./components/InvoiceWebPaymentModals";
import { InvoiceCreditDetailModal } from "./components/InvoiceWebPaymentModals";
import { InvoicePaymentConfirmationDialog } from "./components/InvoiceWebPaymentModals";
import { InvoicePaymentModal } from "./components/InvoiceWebPaymentModals";
import { InvoicePinModal } from "./components/InvoiceWebPaymentModals";
import { InvoiceResultModal } from "./components/InvoiceWebPaymentModals";
import { InvoiceWebHeader } from "./components/InvoiceWebHeader";
import { InvoiceWebHistorySection } from "./components/InvoiceWebHistorySection";
import { InvoiceWebInformationSheet } from "./components/InvoiceWebInformationSheet";
import { InvoiceWebSummarySection } from "./components/InvoiceWebSummarySection";
import {
  InvoiceDataItem,
  InvoiceHistoryDetailItem,
  PaymentSuccessData,
} from "./components/InvoiceWebTypes";
import { isDarkColor } from "../../config/DarkColorChecker";

const INVOICE_ACTIVE_SESSION_KEY = "invoice_active_tab";
const DEFAULT_INVOICE_ACTIVE_TAB = "all";
const INVOICE_ACTIVE_TABS = ["all", "history", "summary"];

const getInitialInvoiceActiveTab = () => {
  try {
    const storedActive = window.sessionStorage.getItem(
      INVOICE_ACTIVE_SESSION_KEY,
    );

    if (storedActive && INVOICE_ACTIVE_TABS.includes(storedActive)) {
      return storedActive;
    }
  } catch (error) {}

  return DEFAULT_INVOICE_ACTIVE_TAB;
};

const ComponentInvoice = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const gaEventTracker = useAnalyticsEventTracker("Invoice");
  const { t } = useTranslation();

  const customApp: CustomApp = useAppSelector(
    (state) => state.customApp.customApp,
  );
  const balance: any = useAppSelector((state) => state.balance.balance);
  const user: User = useAppSelector((state) => state.user.user);

  const [data, setData] = useState<InvoiceDataItem[]>([]);
  const [dataSumary, setDataSumary] = useState<InvoiceDataItem[]>([]);
  const [dataHistory, setDataHistory] = useState<InvoiceDataItem[]>([]);
  const [size, setSize] = useState(10);
  const [page, setPage] = useState(0);
  const [total, setTotal] = useState(0);
  const [showPayment, setShowPayment] = useState(false);
  const [showPin, setShowPin] = useState(false);
  const [confirmation, setConfirmation] = useState(false);
  const [showResult, setShowResult] = useState(false);
  const [dataTemp, setDatatemp] = useState<InvoiceDataItem>({});
  const [dataTempHistory, setDataTempHistory] = useState<
    InvoiceHistoryDetailItem[]
  >([]);
  const [isShowMore, setIsShowMore] = useState(false);
  const [showDescription, setShowDescription] = useState(true);
  const [openInformation, setOpenInformation] = useState(false);
  const [showSort, setShowSort] = useState(false);
  const [showFilter, setShowFilter] = useState(false);

  var invoicea = `${t("INVOICE.title")}`;
  const invoiceTitle = `${t("INVOICE.title")}`;
  var history = `${t("INVOICE.history")}`;
  var summary = `${t("INVOICE.summary")}`;
  var nominal = `${t("INVOICE.placeholder")}`;
  var cash = `${t("INVOICE.cash")}`;
  var paid = `${t("INVOICE.paid")}`;
  var unpaid = `${t("INVOICE.unpaid")}`;
  var partial = `${t("INVOICE.partial")}`;
  const [amount, setAmount] = useState<any>("");
  const [paymentSuccess, setPaymentSuccess] = useState<PaymentSuccessData>({});
  const [isOpen, setIsOpen] = useState(false);
  const [sortBy, setSortBy] = useState("invoiceDate_Desc");
  const [minimumPayment, setMinimumPayment] = useState(0);
  const callerIdentities = user?.accounts?.[0]?.callerIdentities ?? [];
  const singleCallerIdentityId =
    callerIdentities.length === 1
      ? String(callerIdentities[0]?.id ?? callerIdentities[0]?.callerId ?? "")
      : "";
  const [selectedTags, setSelectedTags] = useState<string[]>([]);
  const [selectedStudentId, setSelectedStudentId] = useState(
    singleCallerIdentityId,
  );
  const [draftTags, setDraftTags] = useState<string[]>([]);
  const [draftStudentId, setDraftStudentId] = useState(singleCallerIdentityId);
  const [filterTagOptions, setFilterTagOptions] = useState<string[]>([]);
  const tagSelectOptions = filterTagOptions.map((tag) => ({
    label: tag,
    value: tag,
  }));
  const selectMenuPortalTarget =
    typeof window !== "undefined" ? document.body : undefined;
  const tagSelectStyles = {
    control: (base: any) => ({
      ...base,
      minHeight: 48,
      borderRadius: 12,
      borderColor: "#cbd5e1",
      boxShadow: "none",
    }),
    menuPortal: (base: any) => ({
      ...base,
      zIndex: 70,
    }),
    menu: (base: any) => ({
      ...base,
      zIndex: 70,
    }),
    menuList: (base: any) => ({
      ...base,
      maxHeight: 240,
      overflowY: "auto",
    }),
    multiValue: (base: any) => ({
      ...base,
      backgroundColor: customApp?.app_accent_color,
      color: isDarkColor(customApp?.app_accent_color) ? "#ffffff" : "#000000",
    }),
    multiValueLabel: (base: any) => ({
      ...base,
      color: isDarkColor(customApp?.app_accent_color) ? "#ffffff" : "#000000",
      textTransform: "capitalize",
    }),
    multiValueRemove: (base: any) => ({
      ...base,
      color: isDarkColor(customApp?.app_accent_color) ? "#ffffff" : "#000000",
    }),
  };

  useEffect(() => {
    try {
      if (location.pathname.split("/")[2] != undefined) {
        dispatch(setToken(location.pathname.split("/")[2]));
        if (location.pathname.split("/")[3] != undefined) {
          var lang = location.pathname.split("/")[3];
          i18n.changeLanguage(lang);
          dispatch(setLanguage(lang));
        }
        credentialCheck().then((resCredential) => {
          dispatch(setUser(resCredential.data.user));
          if (resCredential.data.activeCompany.customApps) {
            getCustomApps(
              resCredential.data.activeCompany.id,
              lang.toUpperCase(),
            ).then((resCustom: any) => {
              dispatch(setCustomApp(resCustom.data));
            });
          }
        });
      }
    } catch (error) {}
  }, [location.pathname.split("/")[2]]);

  useEffect(() => {
    getData(page, size);
    getInvoiceTags()
      .then((res: any) => {
        setFilterTagOptions(res.data ?? []);
      })
      .catch(() => {
        setFilterTagOptions([]);
      });
  }, []);

  const sortingOptions = [
    { label: t("SORTING.invoiceDateDesc"), value: "invoiceDate_Desc" },
    { label: t("SORTING.invoiceDateAsc"), value: "invoiceDate_Asc" },
    { label: t("SORTING.dueDateAsc"), value: "dueDate_Asc" },
    { label: t("SORTING.dueDateDesc"), value: "dueDate_Desc" },
    { label: t("SORTING.amountAsc"), value: "amount_Asc" },
    { label: t("SORTING.amountDesc"), value: "amount_Desc" },
  ];

  const handleSortChange = (e: ChangeEvent<HTMLInputElement>) => {
    const sortData = e.target.value;
    setSortBy(sortData);
  };

  const [active, setActive] = useState("all");
  const resolveStudentId = (identityId = selectedStudentId) =>
    identityId || singleCallerIdentityId;

  const getSelectedCallerIds = (identityId = selectedStudentId) => {
    const resolvedIdentityId = resolveStudentId(identityId);
    const selectedIdentity = callerIdentities.find((identity: any) => {
      const identityValue = identity?.id ?? identity?.callerId ?? "";
      return String(identityValue) === String(resolvedIdentityId);
    });

    return selectedIdentity?.callerId ? [selectedIdentity.callerId] : [];
  };

  const getData = async (
    newPage: any,
    newSize: any,
    identityId = selectedStudentId,
    tags = selectedTags,
  ) => {
    dispatch(setLoading(true));
    const sort = sortBy.split("_");
    getAllInvoice(
      newSize,
      newPage,
      sort[0],
      sort[1],
      "",
      "",
      tags,
      getSelectedCallerIds(identityId),
    )
      .then((res: any) => {
        setData(res.data.content);
        setTotal(res.data.totalElements);
        dispatch(setLoading(false));
      })
      .catch(() => {
        dispatch(setLoading(false));
        navigate("/login", { replace: true });
      });
  };

  useEffect(() => {
    if (sortBy) {
      getData(page, size);
      dismissSortDialog();
    }
  }, [sortBy]);

  useEffect(() => {
    if (
      !singleCallerIdentityId ||
      selectedStudentId === singleCallerIdentityId
    ) {
      return;
    }

    setSelectedStudentId(singleCallerIdentityId);
    setDraftStudentId(singleCallerIdentityId);
    setPage(0);

    if (active === "all") {
      getData(0, size, singleCallerIdentityId, selectedTags);
    }
  }, [active, selectedStudentId, selectedTags, singleCallerIdentityId, size]);

  const paymentAction = async () => {
    setShowPayment(false);
    setIsOpen(true);
  };
  const closeAction = async () => {
    setIsOpen(false);
  };

  const openSortDialog = () => {
    setShowSort(true);
  };

  const dismissSortDialog = () => {
    setShowSort(false);
  };

  const openFilterDialog = () => {
    setDraftTags(selectedTags);
    setDraftStudentId(resolveStudentId());
    setShowFilter(true);
  };

  const dismissFilterDialog = () => {
    setShowFilter(false);
  };

  const applyFilters = () => {
    const nextStudentId = resolveStudentId(draftStudentId);

    setSelectedTags(draftTags);
    setSelectedStudentId(nextStudentId);
    setPage(0);
    getData(0, size, nextStudentId, draftTags);
    dismissFilterDialog();
  };

  const resetFilters = () => {
    const nextStudentId = singleCallerIdentityId;

    setDraftTags([]);
    setDraftStudentId(nextStudentId);
    setSelectedTags([]);
    setSelectedStudentId(nextStudentId);
    setPage(0);
    getData(0, size, nextStudentId, []);
    dismissFilterDialog();
  };

  const getInvoicePaid = (newPage: any, newSize: any) => {
    dispatch(setLoading(true));

    getAllInvoicePaid(newSize, newPage, "Desc", "", "")
      .then((res: any) => {
        dispatch(setLoading(false));
        setDataHistory(res.data.content);
      })
      .catch((err: any) => {
        dispatch(setLoading(false));
        navigate("/login", { replace: true });
        console.error(err);
      });
  };

  const getInvoiceSummary = (newPage: any, newSize: any) => {
    dispatch(setLoading(true));
    getAllInvoiceSummary(newSize, newPage, "Desc", "", "")
      .then((res: any) => {
        dispatch(setLoading(false));
        setDataSumary(res.data.content);
        setTotal(res.data.totalElements);
      })
      .catch(() => {
        dispatch(setLoading(false));
        navigate("/login", { replace: true });
      });
  };

  const loadActiveTabData = (tab: string, newPage: any, newSize: any) => {
    switch (tab) {
      case "history":
        return getInvoicePaid(newPage, newSize);
      case "summary":
        return getInvoiceSummary(newPage, newSize);
      case "all":
      default:
        return getData(newPage, newSize);
    }
  };

  useEffect(() => {
    loadActiveTabData(active, page, size);
  }, []);

  useEffect(() => {
    try {
      window.sessionStorage.setItem(INVOICE_ACTIVE_SESSION_KEY, active);
    } catch (error) {}
  }, [active]);

  const mappedData = (invoices: any[]) => {
    return invoices.map((inv: any) => {
      const newDetail = inv.detail.map((d: any) => {
        const match = inv.reference.find((ref: any) => ref.detailId === d.id);
        return {
          ...d,
          transactionAmount: match ? match.amount : 0,
        };
      });
      return {
        ...inv,
        detail: newDetail,
      };
    });
  };

  const getIconInvoice = (item: any) => {
    const { automaticPayment, partialMethod, creditDetailPayment } = item;

    // autodebet
    if (automaticPayment) {
      if (!partialMethod) return autoDebetNonCredit;
      return !creditDetailPayment ? autoDebetCredit : autoDebetPartial;
    }

    // maunal payment
    if (!partialMethod) return invoiceNonCredit;
    return !creditDetailPayment ? invoiceCredit : invoiceCreditPartial;
  };

  const changePage = (newPage: any) => {
    setPage(newPage);
    return loadActiveTabData(active, newPage, size);
  };

  const changeSize = (newSize: any) => {
    setSize(newSize);
    return loadActiveTabData(active, page, newSize);
  };

  const paymentInvoice = async (selectedInvoice: InvoiceDataItem) => {
    var unpaidAmount: any =
      (selectedInvoice.amount || 0) - (selectedInvoice.paidAmount || 0);

    var tempAmount;

    if (selectedInvoice.partialMethod == true) {
      if (parseInt(amount) > unpaidAmount) {
        return toast.warning(
          t("INVOICE.amountNotValid") + formatCurrency(unpaidAmount),
        );
      }
      if (
        unpaidAmount - parseInt(amount) < minimumPayment &&
        unpaidAmount > minimumPayment &&
        unpaidAmount != parseInt(amount)
      ) {
        return toast.warning(t("INVOICE.remainingPayment"));
      }

      if (parseInt(amount) > unpaidAmount) {
        return toast.warning(
          t("INVOICE.amountNotValid") + formatCurrency(unpaidAmount),
        );
      }
      if (parseInt(amount) < minimumPayment && unpaidAmount > minimumPayment) {
        return toast.warning(t("INVOICE.placeholder"));
      }
      if (balance < parseInt(amount)) {
        return toast.warning(
          t("INVOICE.balanceEmpty") + formatCurrency(balance),
        );
      }

      tempAmount = amount;
    } else {
      if (balance < unpaidAmount) {
        return toast.warning(
          t("INVOICE.balanceEmpty") + formatCurrency(balance),
        );
      }
      tempAmount = unpaidAmount.toString();
    }
    var query = {
      amount: parseInt(tempAmount),
      cash: true,
      channel: "MOBILE",
      invoiceId: selectedInvoice.invoiceId,
      tag: "",
    };

    dispatch(setLoading(true));
    invoicePayment(query)
      .then((res) => {
        dispatch(setLoading(false));
        getData(page, size);
        setActive("all");
        setShowPayment(false);
        setPaymentSuccess(res.data);
        getBalance()
          .then((balanceResponse) => {
            dispatch(setBalance(balanceResponse.data.balance));
          })
          .catch(() => {
            dispatch(removeUser());
            dispatch(removeBalance());
            navigate("/login", { replace: true });
          });
        toast.success(t("OTHER.success"));
        gaEventTracker("Click Payment", "Payment Invoice Success");

        setShowResult(true);
      })
      .catch((err: any) => {
        console.error(err);
        dispatch(setLoading(false));
      });
  };

  const payment = (item: InvoiceDataItem) => {
    setDatatemp(item);

    setDataTempHistory(
      (item.history || []).map((historyItem: any) => {
        return {
          dateTime: historyItem.dateTime,
          detail: historyItem.reference.map((reference: any) => {
            const detailInfo = (item.detail || []).find(
              (detail: any) => detail.id === reference.detailId,
            );

            return detailInfo
              ? { ...detailInfo, transactionAmount: reference.amount }
              : {
                  detailId: reference.detailId,
                  amount: reference.amount,
                  note: "Detail not found",
                };
          }),
        };
      }),
    );
    let minPayment = item.minimumPayment || 0;
    if (item.minimumPaymentType === "PERCENT") {
      minPayment =
        ((item.minimumPayment || 0) / 100) *
        ((item.amount || 0) - (item.paidAmount || 0));
    }
    setMinimumPayment(minPayment);
    setShowPayment(true);
    setShowPin(false);
    setConfirmation(false);
    setShowResult(false);
    if (item?.partialMethod !== false) {
      setAmount(String((item?.amount || 0) - (item?.paidAmount || 0)));
    }
  };

  const onDismissInformation = () => {
    setOpenInformation(false);
  };

  const pin = () => {
    setShowPayment(false);
    setShowPin(true);
    setConfirmation(false);
    setShowResult(false);
  };

  const confirm = () => {
    setShowPayment(false);
    setShowPin(false);
    setConfirmation(true);
    setShowResult(false);
  };

  const sukses = () => {
    setShowPayment(false);
    setShowPin(false);
    setConfirmation(false);
    setShowResult(true);
  };

  const downloadImage = (
    elementId: string,
    fileName: string,
    onComplete?: () => void,
  ) => {
    const input = document.getElementById(elementId);

    if (!input) {
      onComplete?.();
      return;
    }

    html2canvas(input, { logging: true, useCORS: true }).then((canvas) => {
      const url = canvas.toDataURL();
      const downloadLink = document.createElement("a");

      downloadLink.href = url;
      downloadLink.download = fileName;
      downloadLink.click();
      onComplete?.();
    });
  };

  const onClick = () => {
    setShowDescription(false);
    setTimeout(() => {
      downloadImage(
        "Detail",
        `${dataTemp?.title} - ${dataTemp?.callerName}`,
        () => setShowDescription(true),
      );
    }, 1000);
  };

  // const downloadImage = () => {
  //   const input: any = document.getElementById("Detail");
  //   html2canvas(input, { logging: true, useCORS: true }).then(
  //     (canvas: HTMLCanvasElement) => {
  //       const url: any = canvas.toDataURL();
  //       setImage(url);
  //       const linkSource = url;
  //       const downloadLink = document.createElement("a");
  //       downloadLink.href = linkSource;
  //       downloadLink.download = dataTemp?.title + " - " + dataTemp?.callerName;
  //       downloadLink.click();
  //       setShowDescription(true);
  //     }
  //   );
  // };

  const handleTabChange = (tab: string) => {
    loadActiveTabData(tab, page, size);
    setActive(tab);
  };
  const onClick2 = () => {
    downloadImage("DetailPay", `${dataTemp?.title} - ${dataTemp?.callerName}`);
  };
  const handleCreditDetailPayment = () => {
    if (
      dataTemp.partialMethod &&
      dataTemp.creditDetailPayment &&
      dataTemp.detail?.reduce((totalPaid: any, detail: any) => {
        return totalPaid + detail.paidAmount;
      }, 0) != dataTemp.paidAmount
    ) {
      toast.error("Pembayaran tagihan ini tidak dapat dilakukan.");
    } else if (!dataTemp.partialMethod && !dataTemp.creditDetailPayment) {
      console.log("should be true");

      paymentAction();
    } else {
      navigate(`/invoice-credit-payment`, {
        state: { data: dataTemp },
      });
    }
  };

  return (
    <div className="bg-psp-primary pb-20 font-montserrat">
      <StatsInvoice />
      <div className="container relative w-full -mt-44 bg-white shadow rounded-2xl pb-10">
        <div className="container h-full w-full">
          <InvoiceWebHeader
            active={active}
            accentColor={customApp?.app_accent_color}
            title={invoiceTitle}
            t={t}
            onOpenInformation={() => setOpenInformation(true)}
            onTabChange={handleTabChange}
          />

          {active === "summary" ? (
            <InvoiceWebSummarySection
              data={dataSumary}
              page={page}
              size={size}
              total={total}
              title={invoiceTitle}
              accentColor={customApp?.app_accent_color}
              t={t}
              onChangePage={changePage}
              onChangeSize={changeSize}
            />
          ) : active === "history" ? (
            <InvoiceWebHistorySection
              data={dataHistory}
              page={page}
              size={size}
              total={total}
              title={invoiceTitle}
              accentColor={customApp?.app_accent_color}
              language={i18n.language}
              t={t}
              onOpenSort={openSortDialog}
              onChangePage={changePage}
              onChangeSize={changeSize}
              onSelectItem={payment}
              getIconInvoice={getIconInvoice}
            />
          ) : (
            <InvoiceTabComponent onSelectItem={payment} />
          )}
        </div>

        <InvoiceWebInformationSheet
          open={openInformation}
          onDismiss={onDismissInformation}
        />

        <InvoicePaymentConfirmationDialog
          isOpen={isOpen}
          t={t}
          onClose={closeAction}
          onConfirm={() => paymentInvoice(dataTemp)}
        />

        <InvoiceCreditDetailModal
          show={
            showPayment &&
            dataTemp?.creditDetailPayment === false &&
            dataTemp?.partialMethod === false
          }
          active={active}
          dataTemp={dataTemp}
          dataTempHistory={dataTempHistory}
          userName={user?.name}
          accentColor={customApp?.app_accent_color}
          cashLabel={cash}
          language={i18n.language}
          t={t}
          onClose={() => setShowPayment(false)}
          onPay={handleCreditDetailPayment}
        />
        {/* credit */}
        <InvoicePaymentModal
          show={
            showPayment &&
            dataTemp?.creditDetailPayment === false &&
            dataTemp?.partialMethod === true
          }
          active={active}
          paidLabel={paid}
          unpaidLabel={unpaid}
          partialLabel={partial}
          nominalLabel={nominal}
          minimumPayment={minimumPayment}
          dataTemp={dataTemp}
          userName={user?.name}
          accentColor={customApp?.app_accent_color}
          cashLabel={cash}
          language={i18n.language}
          showDescription={showDescription}
          isShowMore={isShowMore}
          t={t}
          onClose={() => setShowPayment(false)}
          onAmountChange={(value?: string) => setAmount(value)}
          onPrimaryAction={paymentAction}
          onDownload={onClick}
          onToggleShowMore={() => setIsShowMore(!isShowMore)}
        />
        <InvoiceCreditDetailModal
          show={
            showPayment &&
            dataTemp?.creditDetailPayment === true &&
            dataTemp?.partialMethod === true
          }
          active={active}
          dataTemp={dataTemp}
          dataTempHistory={dataTempHistory}
          userName={user?.name}
          accentColor={customApp?.app_accent_color}
          cashLabel={cash}
          language={i18n.language}
          t={t}
          onClose={() => setShowPayment(false)}
          onPay={handleCreditDetailPayment}
        />

        {/* <InvoiceCreditDetailModal
          show={showPayment && dataTemp?.creditDetailPayment === false}
          active={active}
          dataTemp={dataTemp}
          userName={user?.name}
          accentColor={customApp?.app_accent_color}
          cashLabel={cash}
          paidLabel={paid}
          unpaidLabel={unpaid}
          partialLabel={partial}
          nominalLabel={nominal}
          minimumPayment={minimumPayment}
          language={i18n.language}
          showDescription={showDescription}
          isShowMore={isShowMore}
          t={t}
          onAmountChange={handleAmountChange}
          onPrimaryAction={paymentAction}
          onDownload={onClick}
          onClose={handleClosePaymentFlow}
          onToggleShowMore={() => setIsShowMore(!isShowMore)}
        /> */}

        <InvoicePinModal show={showPin} onConfirm={confirm} />

        <InvoiceConfirmationModal show={confirmation} onConfirm={sukses} />

        <InvoiceResultModal
          show={showResult}
          dataTemp={dataTemp}
          paymentSuccess={paymentSuccess}
          userName={user?.name}
          accentColor={customApp?.app_accent_color}
          cashLabel={cash}
          t={t}
          onDownload={onClick2}
          onClose={() => setShowResult(false)}
        />
      </div>
    </div>
  );
};

export default ComponentInvoice;
